module.exports = __webpack_public_path__ + "img/Secured_by_CyStack.3aab9ecc.svg";